import { MutateFunction } from 'react-query';
import axios from 'axios';
import { message } from 'src/antd';
import React from 'react';
import { T } from '@transifex/react';
import { APIError } from '../consts/error';

type TVerificationType = 'sms' | 'email';

type TVariables = {
  token: string;
  captcha_token: string;
  verification_type: TVerificationType;
  phone_number?: string;
  email?: string;
};

type TResponse = {
  next_attempt_timestamp: number;
};

export const mutateSendVerificationCode: MutateFunction<
  { data: TResponse },
  unknown,
  TVariables
> = ({ token, verification_type, email, phone_number, captcha_token }) =>
  axios
    .post(
      `notifications/send-verification-code`,
      {
        verification_type,
        email,
        phone_number,
        captcha_token,
      },
      {
        headers: {
          'X-API-Key': token,
        },
      }
    )
    .catch((e) => {
      if (e?.response?.data?.message) {
        message.error(e?.response?.data?.message);
        throw new APIError(e?.response?.data?.message, {
          ERROR_MESSAGE_HANDLED: true,
        });
      } else {
        message.error(
          <T _str="Something went wrong. Please try again later." />
        );
        throw new APIError('invalid_phone_number', {
          ERROR_MESSAGE_HANDLED: true,
        });
      }
    });
